import api from './api';

export const authService = {
  /**
   * Register a new user
   */
  async register(email, password, fullName) {
    const response = await api.post('/auth/register', {
      email,
      password,
      full_name: fullName,
    });
    return response.data;
  },

  /**
   * Login user
   */
  async login(email, password) {
    const response = await api.post('/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  /**
   * Logout user
   */
  async logout() {
    try {
      await api.post('/auth/logout');
    } finally {
      localStorage.removeItem('authToken');
    }
  },

  /**
   * Get current user profile
   */
  async getProfile() {
    const response = await api.get('/users/me');
    return response.data;
  },

  /**
   * Update user profile
   */
  async updateProfile(data) {
    const response = await api.put('/users/me', data);
    return response.data;
  },

  /**
   * Change password
   */
  async changePassword(currentPassword, newPassword) {
    const response = await api.put('/users/me/password', null, {
      params: {
        current_password: currentPassword,
        new_password: newPassword,
      },
    });
    return response.data;
  },

  /**
   * Request password reset
   */
  async requestPasswordReset(email) {
    const response = await api.post('/auth/password-reset', null, {
      params: { email },
    });
    return response.data;
  },

  /**
   * Get usage statistics
   */
  async getUsageStats() {
    const response = await api.get('/users/me/usage');
    return response.data;
  },
};

export default authService;
